


'use client';
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { opacity, slideUp } from './aim';

interface IndexProps {
    words: string[];
}

const Index: React.FC<IndexProps> = ({ words = [] }) => {
    const [index, setIndex] = useState(0);
    const [dimension, setDimension] = useState({ width: 0, height: 0 });
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (typeof window !== "undefined") {
            setDimension({ width: window.innerWidth, height: window.innerHeight });
        }
    }, []);

    useEffect(() => {
        if (index === words.length - 1) return;
        const timer = setTimeout(() => {
            setIndex(index + 1);
        }, index === 0 ? 1000 : 150);
        return () => clearTimeout(timer);
    }, [index, words.length]);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prevProgress) => {
                if (prevProgress < 100) {
                    return prevProgress + 10;
                } else {
                    clearInterval(interval);
                    return prevProgress;
                }
            });
        }, 100);
        return () => clearInterval(interval);
    }, []);

    return (
        <motion.div
            variants={slideUp}
            initial="initial"
            exit="exit"
            className="h-full w-full lg:w-screen lg:h-screen bg-smoke fixed flex items-center justify-center z-[99]"
        >
            {dimension.width > 0 && (
                <div>
                    <motion.p
                        className="text-6xl w-[340px] md:w-[unset] lg:text-7xl xl:text-8xl 3xl:text-9xl 4xl:text-[140px] font-jedira text-lemone text-center"
                        variants={opacity}
                        initial="initial"
                        animate="enter"
                    >
                        {words[index]}
                    </motion.p>
                </div>
            )}
        </motion.div>
    );
};

export default Index;

